import { Injectable, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { uniqBy } from 'lodash';

import { MasterCreateProfileComponent } from '../views/permissoes/master-create-profile.component';

interface Users {}

interface Isteps {
  nameProfile: boolean;
  permissionChoiced: boolean;
}
@Injectable()
export class MasterHomeCreateProfileService {
  form: FormGroup;

  constructor(private formBuilder: FormBuilder) {
    this.form = this.formBuilder.group({
      name: [null, [ Validators.required, Validators.maxLength(50)]],
      description: [null, [Validators.maxLength(250)]],
    });
  }

  @Output() stepsOfCreateProfile: EventEmitter<any> = new EventEmitter<any>();
  static checkDuplicate = new EventEmitter<any>();
  static emitirListProfiles = new EventEmitter<any>();
  roles: any = [];
  node: string;
  role: any = [];
  namePermission: string;
  permissionDescription: string;

  setRoles(roles, node) {
    roles.map(role => {
      role.typeNode = node;
      this.addRole(role);
    });
  }
  addRole(role) {
    this.role.push(role);
    this.checkDuplicateValues();
    this.groupRoles();
  }

  groupRoles() {
    const users = [];
    const roles = [];
    this.role.forEach(r => {
      if (r.typeNode == 'profile') {
        roles.push(r);
        this.roles['profile'] = roles;
      }

      if (r.typeNode == 'users') {
        users.push(r);
        this.roles['users'] = users;
      }
    });
    this.getUsersSelected();
    this.getRolesSelected();
    MasterHomeCreateProfileService.emitirListProfiles.emit(this.roles);
  }

  checkDuplicateValues() {
    this.role = uniqBy(this.role, 'id');
  }

  getUsersSelected() {
    if (this.roles['users']) {
      return this.roles['users']
        .filter(user => user.checked == true)
        .map(e => {
          return { user_id: e.id };
        });
    }
  }

  getRolesSelected() {
    if (this.roles['profile']) {
      return this.roles['profile']
        .filter(prof => prof.checked == true)
        .map(e => {
          return { id: e.id };
        });
    }
  }

  dataPermissions() {
    return {
      permissions: this.getRolesSelected(),
    };
  }

  async dataToAssociateUsers(idRoleCreated) {
    return await this.getUsersSelected().map(user => {
      return {
        ...user,
        profile: {
          id: idRoleCreated,
        },
      };
    });
  }
}
